import { CURRENT_TENANT } from "./tenant";

export const PROTOCOL = process.env.BARESTO_PROTOCOL;
export const PORT = process.env.BARESTHO_PORT;
export const API_DOMAIN = process.env.BARESTO_API;
export const PUBLIC_DOMAIN = process.env.BARESTHO_PUBLIC_DOMAIN;
export const RESERVATION_DOMAIN = process.env.BARESTHO_RESERVATION_DOMAIN;

export const SHOP_URL = `${PROTOCOL}://${CURRENT_TENANT}.${RESERVATION_DOMAIN}/shopping/`;



// WEBPACK FOOTER //
// ./src/constants/url.js